import * as React from 'react'
import DevTools from 'mobx-react-devtools'
import { Switch, Route } from 'react-router'

import style from './App.module.css'

import { injectStores, StoreComponent } from './store'
import { observer } from 'mobx-react'
import { MatchMediaProvider } from 'mobx-react-matchmedia'
import { Karte } from './modules/karte/karte'

@injectStores
@observer
export class App extends StoreComponent<any> {

  componentDidMount () {
    if (document.documentElement && 'ontouchstart' in document.documentElement) {
      document.body.style.cursor = 'pointer'
    }
  }

  public render () {

    let content
    // render content only after we know if its desktop or
    if (this.store.breakpoints.desktop === true || this.store.breakpoints.phone === true) {
      content = (
        <Switch>
          <Route component={Karte} />
        </Switch>
      )
    }

    return (
      <div className={style.AppContainer}>
        {content}
        {process.env.NODE_ENV === 'development' && <DevTools />}
        <MatchMediaProvider breakpoints={this.store.breakpoints} />
      </div >

    )
  }
}

export default App
